// Add this to your JavaScript file or script tag
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('a[href*="instagram.com"]').forEach(link => {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
    });
});

// Function to check and update the add to cart button state
function checkAndUpdateAddToCart() {
    const productForm = document.querySelector('.product-form');
    const addToCartButton = document.querySelector('.variant-addtocart-pdp');
    
    if (!addToCartButton) return;
    
    // Check if there's any element with sb-cfp-badge-wrap inside product-form
    const hasBadge = productForm && productForm.querySelector('.sb-cfp-badge-wrap');
    
    if (hasBadge) {
        // If badge is found and button is not already hidden, add hidden class with blur transition
        if (!addToCartButton.classList.contains('hidden')) {
            // First apply blur filter for smooth transition
            addToCartButton.style.filter = 'blur(3px)';
            addToCartButton.style.transition = 'filter 0.3s ease, opacity 0.3s ease';
            
            // After 3 seconds, add the hidden class
            setTimeout(() => {
                addToCartButton.classList.add('hidden');
                // Remove the blur after hiding
                setTimeout(() => {
                    addToCartButton.style.filter = 'none';
                }, 300);
            }, 3000);
        }
        // If already hidden, keep it hidden
    } else {
        // If badge is not found, remove hidden class after a delay
        if (addToCartButton.classList.contains('hidden')) {
            setTimeout(() => {
                addToCartButton.classList.remove('hidden');
            }, 1000); // Remove hidden after 1 second
        }
    }
}

// Track the current state
let isCurrentlyHidden = false;

// Function to monitor changes
function monitorAddToCartState() {
    const productForm = document.querySelector('.product-form');
    const addToCartButton = document.querySelector('.variant-addtocart-pdp');
    
    if (!addToCartButton) return;
    
    const hasBadge = productForm && productForm.querySelector('.sb-cfp-badge-wrap');
    const isHidden = addToCartButton.classList.contains('hidden');
    
    // Only trigger update if state changed
    if ((hasBadge && !isHidden) || (!hasBadge && isHidden)) {
        checkAndUpdateAddToCart();
    }
}

// Initial check when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
    checkAndUpdateAddToCart();
    
    // Set up continuous monitoring
    const monitoringInterval = setInterval(monitorAddToCartState, 2000);
});

// Monitor for when elements are added/removed from the product-form
const observer = new MutationObserver(function(mutations) {
    let shouldCheck = false;
    
    mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
            // Check if any added or removed node affects our badge
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1 && 
                    (node.classList?.contains('sb-cfp-badge-wrap') || 
                     node.querySelector?.('.sb-cfp-badge-wrap'))) {
                    shouldCheck = true;
                }
            });
            
            mutation.removedNodes.forEach(function(node) {
                if (node.nodeType === 1 && 
                    (node.classList?.contains('sb-cfp-badge-wrap') || 
                     node.querySelector?.('.sb-cfp-badge-wrap'))) {
                    shouldCheck = true;
                }
            });
        }
    });
    
    if (shouldCheck) {
        checkAndUpdateAddToCart();
    }
});

// Start observing the product-form for changes
const productForm = document.querySelector('.product-form');
if (productForm) {
    observer.observe(productForm, {
        childList: true,
        subtree: true
    });
}